import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/view/index'
const home = r => require.ensure([], () => r(require('@/components/home')))
const index = r => require.ensure([], () => r(require('@/view/index')))
const join = r => require.ensure([], () => r(require('@/view/join')))
const certification = r => require.ensure([], () => r(require('@/view/certification')))
const trailer = r => require.ensure([], () => r(require('@/view/trailer')))
const news = r => require.ensure([], () => r(require('@/view/news')))
const cooperate = r => require.ensure([], () => r(require('@/view/cooperate')))
const newsDetail = r => require.ensure([], () => r(require('@/view/newsDetail')))
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      redirect: '/home/index',
      children: [
        {
          path: '/home/index',
          name: 'index',
          component: index
        },
        {
          path: '/home/join',
          name: 'join',
          component: join
        }, {
          path: '/home/certification',
          name: 'certification',
          component: certification
        }, {
          path: '/home/trailer',
          name: 'trailer',
          component: trailer
        }, {
          path: '/home/news',
          name: 'news',
          component: news
        }, {
          path: '/home/newsDetail',
          name: 'newsDetail',
          component: newsDetail
        }, {
          path: '/home/cooperate',
          name: 'cooperate',
          component: cooperate
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js